<template>
    <div>
        <head-view></head-view>        
        <div class="allGameViewVue w"><!-- style="color: red;" -->
        <div class="title all" >所有应用>
            <!-- <a href="">查看所有游戏></a> -->
        </div>
        <!-- <div class="text">Few Step For a New Home</div> -->
        <div class="process-img">
            <ul>
                <li>
                    <router-link to="/oneGameViewVue">
                        <img src="@/assets/img/MHLH/icon1-512.png" alt="">
                    </router-link>
                    <p class="step">
                        <router-link to="/oneGameViewVue">魔幻轮回</router-link> 
                    </p>
                </li>
                <li>
                    <router-link to="/mkqy02GameVue">
                        <img src="@/assets/img/02MKQY/216.png" alt="">
                    </router-link>
                    <p class="step">
                        <router-link to="/mkqy02GameVue">魔卡契约</router-link> 
                    </p>
                </li>
                <li>
                    <router-link to="/fzwlqx03GameVue">
                        <img src="@/assets/img/FZWLQX/1.png" alt="">
                    </router-link>
                    <p class="step">
                        <router-link to="/fzwlqx03GameVue">放置：蔚蓝前线</router-link> 
                    </p>
                </li>
                <li>
                    <router-link to="/ai02WJZHGameVue">
                        <img src="@/assets/img/AI02WJZH/1.png" alt="">
                    </router-link>
                    <p class="step">
                        <router-link to="/ai02WJZHGameVue">放置：无尽之海</router-link> 
                    </p>
                </li>
                <!-- <li>
                    <img src="@/assets/img/20250213204801.png" alt="">
                    <p class="step">step1 选择宠物</p>
                </li>
                <li>
                    <img src="@/assets/img/20250213204801.png" alt="">
                    <p class="step">step1 选择宠物</p>
                </li>
                <li>
                    <img src="@/assets/img/20250213204801.png" alt="">
                    <p class="step">step1 选择宠物</p>
                </li> -->
            </ul>
        </div>
    </div>
    <footer-view></footer-view><!-- 底部隐私协议等 -->
    </div>
</template>
<script>
import FooterView from '../footer/footerView.vue';
import headView from '../header/headView.vue'
export default {
  components: { headView, FooterView },
}
</script>
<style scoped>
.process-img ul {
    display: flex;
    justify-content: center;   /* 整体居中 */
    gap: 100px;                 /* 两个图片之间的间隔 */
    flex-wrap: wrap;   /* 自动换行 */
    padding: 0;
    margin: 0;
    list-style: none;
}
</style>